/**
 * Intro Text Animation Logic - Precision Timing Optimized
 */

document.addEventListener("DOMContentLoaded", () => {
	if (typeof gsap === "undefined") {
		console.warn("GSAP not found. Intro Text animation skipped.");
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	// Ochranná podmienka pre prémiový plugin
	if (typeof SplitText !== "undefined") {
		gsap.registerPlugin(SplitText);
	} else {
		console.warn("GSAP SplitText not found. Falling back to simple fade.");
	}

	const intros = document.querySelectorAll('.wp-block-osmerova-intro-text');

	intros.forEach((intro) => {
		const animationType = intro.getAttribute('data-gsap');

		let ctx = gsap.context(() => {
			// Najprv si zadefinujeme samotný vnútorný kontajner (Kľúčové pre správne časovanie)
			const container = intro.querySelector('.osmerova-intro__container');
			const elements = container ? container.querySelectorAll('p.is-style-heading-text, div.wp-block-osmerova-cta-button') : null;

			if (!container || !elements || elements.length === 0) return;

			if (animationType === 'text-reveal-scrub') {
				gsap.set(intro, { autoAlpha: 1, visibility: "visible" });

				if (typeof SplitText !== "undefined") {
					const split = new SplitText(elements, { type: "chars, words" });

					// Počiatočný stav - bledá Mist farba
					gsap.set(split.chars, {
						color: "var(--osm-morning-mist, #ccc)",
						opacity: 0.5
					});

					// Odhalenie na čierno (Text Reveal)
					gsap.to(split.chars, {
						color: "var(--osm-color-text-main, #000)",
						opacity: 1,
						stagger: 0.1,
						ease: "none",
						scrollTrigger: {
							// FIX: Sledujeme výlučne obal s textom, nezaujíma nás výška celej sekcie
							trigger: container,
							// Animácia sa začne, keď sa vrch textu dostane do 70% obrazovky (zhora)
							start: "top 70%",
							// Animácia sa DOKONČÍ, keď sa spodok textu dostane do 40% obrazovky (bezpečne v strede)
							end: "bottom 40%",
							scrub: 1,
						}
					});

				} else {
					// Fallback
					gsap.from(elements, {
						scrollTrigger: {
							trigger: container,
							start: "top 80%",
						},
						y: 40,
						opacity: 0,
						duration: 0.8,
						stagger: 0.15,
						ease: "power2.out"
					});
				}
			} else if (animationType === 'fade-in') {
				gsap.set(elements, { autoAlpha: 0, y: 30 });

				gsap.to(elements, {
					scrollTrigger: {
						trigger: container,
						start: "top 80%",
					},
					ease: "power2.out",
					autoAlpha: 1,
					y: 0,
					duration: 1,
					stagger: 0.2,
					clearProps: "all" // Čistenie inline štýlov po animácii pre čistý DOM
				});
			}

		}, intro);
	});
});
